export enum BillDeferredReason {
  NewPaymentMethod = "new_payment_method",
  NoPaymentMethod = "no_payment_method",
  PaymentTerms = "payment_terms",
}
